import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { BalrogadminSharedModule } from '../shared';

import { HOME_ROUTE, HomeComponent, HomeCanActivate } from './';

@NgModule({
    imports: [
        BalrogadminSharedModule,
        RouterModule.forChild([ HOME_ROUTE ])
    ],
    declarations: [
        HomeComponent,
    ],
    entryComponents: [
    ],
    providers: [
        HomeCanActivate
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BalrogadminHomeModule {}
